module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop2.95b2c7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop2.jpg
// module id = /+DP
// module chunks = 0